import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const head = document.getElementsByTagName('head')[0];

if (
  environment.OnetrustCookieConsentKey == null ||
  environment.OnetrustCookieConsentKey == ''
) {
  environment.OnetrustCookieConsentKey = 'cd77d875-c162-48c6-86ed-8bbae7dda63d';
}

const consentKey = environment.OnetrustCookieConsentKey;

const scriptAutoblock = document.createElement('script');
scriptAutoblock.type = 'text/javascript';
scriptAutoblock.src = `https://cdn.cookielaw.org/consent/${consentKey}/OtAutoBlock.js`;
head.appendChild(scriptAutoblock);

const scriptOneTrustCookie = document.createElement('script');
scriptOneTrustCookie.type = 'text/javascript';
scriptOneTrustCookie.src =
  'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
scriptOneTrustCookie.setAttribute('data-domain-script', consentKey);
scriptOneTrustCookie.setAttribute('data-language', 'en');
scriptOneTrustCookie.setAttribute('charset', 'UTF-8');
head.appendChild(scriptOneTrustCookie);

const liveChat = document.createElement('script');
liveChat.type = 'text/javascript';
liveChat.src = '../src/liveChat/liveChat.js';
head.appendChild(liveChat);

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
